import styled from "styled-components";

export const SectionTitle = styled.header`
  font-family: "Noto Sans KR";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  justify-content: flex-start;
  line-height: 140%; /* 44.8px */
  margin-left: ${(props) => props.$left}px;
`;

export const Container = styled.div`
  display: flex;
  background: #ffffff;
  width: ${(props) =>
    props.$width !== undefined ? `${props.$width}px` : "100%"};
  height: ${(props) => props.$height}px;
  margin-left: ${(props) =>
    props.$left !== undefined ? `${props.$left}px` : 0};
  margin-right: ${(props) =>
    props.$right !== undefined ? `${props.$right}px` : 0};
  margin-top: ${(props) => (props.$top !== undefined ? `${props.$top}px` : 0)};
  margin-bottom: ${(props) =>
    props.$bottom !== undefined ? `${props.$bottom}px` : 0};
  // margin: 0 auto;
  border-radius: 4px;
  // justify-content: flex-start;
  padding: 18px 20px 18px 20px;
  align-items: center;
  border-radius: 4px;
`;

export const Container2 = styled.div`
  display: flex;
  background: #ffffff;
  width: ${(props) =>
    props.$width !== undefined ? `${props.$width}px` : "100%"};
  height: ${(props) => props.$height}px;
  margin-left: ${(props) =>
    props.$left !== undefined ? `${props.$left}px` : 0};
  margin-right: ${(props) =>
    props.$right !== undefined ? `${props.$right}px` : 0};
  margin-top: ${(props) => (props.$top !== undefined ? `${props.$top}px` : 0)};
  margin-bottom: ${(props) =>
    props.$bottom !== undefined ? `${props.$bottom}px` : 0};
  // margin: 0 auto;
  border-radius: 4px;
  justify-content: flex-start;
  padding: 0px;
  align-items: center;
  border-radius: 4px;
`;

export const Row1 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  margin-bottom: 15px;
  margin-right: ${(props) =>
    props.$left !== undefined ? `${props.$left}px` : 0};
`;

export const Column1 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  // width: 100%;
  // margin: 0px;
`;

export const Column22 = styled.div`
  // flex-direction: column;
  width: 100%;
`;

export const Row2 = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  margin-right: ${(props) =>
    props.$left !== undefined ? `${props.$left}px` : 0};
`;
export const Row2Item = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  margin-left: -20px;
  margin-right: 20px;
`;
export const Row3 = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 5px;
`;
export const Row5 = styled.div`
  display: flex;
  flex-direction: row;
  // margin-right: 5px;
  margin-top: 5px;
  justify-content: flex-end;
`;
export const Row4 = styled.div`
  display: flex;
  flex-direction: row;
`;
export const Category = styled.div`
  font-family: "NotoSansKR";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  margin-right: -15px;
  display: flex;
  width: 70px;
  height: 22px;
  color: ${(props) => props.$color};
`;
export const DataTitle = styled.p`
  font-family: "NotoSansKR";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin-right: 30px;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  justify-content: flex-end;
  color: ${(props) => props.$color};
`;
export const ContentContainer = styled.div`
  display: flex;
  justify-content: ${(props) => props.$flex};
  width: ${(props) => (props.$width !== undefined ? `${props.$width}px` : "450px")};
  height: ${(props) => props.$height}px;
  // margin: 0px;
  justify-content: flex-start;
`;
export const ContentContainerRight = styled.div`
  display: flex;
  width: 100%;
  height: ${(props) => props.$height}px;
  justify-content: flex-end;
  margin-bottom: ${(props) => props.$bottom}px;
  margin-left: 30px;
`;

export const NoticeTitle = styled.div`
  font-family: "NotoSansKR";
  font-size: 14px;
  font-style: normal;
  font-weight: 900;
  line-height: 140%;
  margin-bottom: 8px;
`;
export const NoticeCont = styled.div`
  font-family: "NotoSansKR";
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  margin-bottom: 8px;
`;
export const ViewCnt = styled.p`
  font-family: "NotoSansKR";
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  color: #0b589a;
  margin: 0;
  margin-left: 5px;
`;
export const ProgressContainer = styled.div`
  width: ${(props) => props.$width}px;
  height: ${(props) => props.$height}px;
  margin: 0px;
  background: ${(props) => props.$background};
  color: #ffffff;
  padding: 10 0 0 10px;
`;

export const EmptyText = styled.header`
  font-family: "NotoSansKR";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  display: flex;
  margin-left: ${(props) => props.$left}px;
  justify-content: center;
  color: ${(props) => props.$color};
  background: "green";
`;

export const EmptyLayOut = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 100px 0;
  width: 100%;
`;

export const GridContainer = styled.div`
  display: grid;
  margin-top: 20px;
  grid-template-rows: repeat(2, 1fr); // 행 2개로 구성한다.
  grid-template-columns: repeat(2, 1fr); // 열 2개로 구성한다.
  // gap: 0px;  // 각 셀 사이의 간격을 설정한다.
  grid-column-gap: 50px;
`;

export const MainPro = styled.header`
  font-family: "Noto Sans KR";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  width: 219px;
  margin-left: 20px;
  margin-top: ${(props) => props.$top ?? 10}px;
`;
export const TitlePro = styled.div`
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  margin-left: 20px;
  // width: 40px;
  // height: 22px;
  display: flex;
  justify-content: flex-start;
  margin-top: ${(props) => props.$top}px;
`;
export const CircleText = styled.header`
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  width: 219px;
  margin-right: 40px;
  margin-top: -10px;
  margin-left: -10px;
  margin-bottom: 10px;
`;
